import $ from './lib/jquery';
import "magnific-popup";
// import'bootstrap/dist/js/bootstrap.bundle';
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js')
// import Masonry from 'masonry-layout';
var jQueryBridget = require('jquery-bridget/jquery-bridget');
var Masonry = require( 'masonry-layout' );
// make Masonry a jQuery plugin
jQueryBridget( 'masonry', Masonry, $ );
// import 'parsleyjs';
import ScrollBooster from 'scrollbooster';
import 'focus-visible/dist/focus-visible.min';
import 'jquery-focuspoint/js/jquery.focuspoint';
var PhotoSwipeLightbox = require('photoswipe/dist/umd/photoswipe-lightbox.umd.min.js');
var PhotoSwipe = require('photoswipe/dist/umd/photoswipe.umd.min.js');
var PhotoSwipeDynamicCaption  = require('photoswipe-dynamic-caption-plugin/dist/photoswipe-dynamic-caption-plugin.umd.min.js');
// import {WebpMachine} from "webp-hero"
// const webpMachine = new WebpMachine();
// webpMachine.polyfillDocument();
var msnry;
import 'imagesloaded';
import Swiper from 'swiper/swiper-bundle';
import 'magnific-popup/dist/jquery.magnific-popup';


// extension method: listen on class change
$.fn.onClassChange = function(cb) {
    return $(this).each((_, el) => {
        new MutationObserver(mutations => {
            mutations.forEach(mutation => cb && cb(mutation.target, mutation.target.className));
        }).observe(el, {
            attributes: true,
            attributeFilter: ['class'] // only listen for class attribute changes
        });
    });
}
//scroll to anchor
document.querySelectorAll('a[href^="#"]:not(.nav-link)').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

$( document ).ready(function() {
    /**
     * Name           : MagnificPopup
     * Beschreibung   : PopUps und Lightbox für Artikelbilder, Hinweise und Formulare
     * Parameter      : Klasse des Elements
     * Rückgabe       : -
     * Bibliothek     : jQuery, Magnific Popup (magnific_min.js)
     */
    var groups = {};
    $('.mfp').each(function() {
        var id = parseInt($(this).attr('data-group'), 10);

        if(!groups[id]) {
            groups[id] = [];
        }

        groups[id].push( this );
    });

    $.each(groups, function() {

        $(this).magnificPopup({
            type: 'image',
            closeOnContentClick: true,
            closeBtnInside: false,
            gallery: {
                enabled:true,
                tCounter: '<span class="mfp-counter">%curr% von %total%</span>' // markup of counter
            }
        })

    });

    /**
     * Name           : Swiper
     * Beschreibung   : The Most Modern Mobile Touch Slider
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : https://swiperjs.com
     */
    if ( $( ".swiper-gallery" ).length ) {
        $(".swiper-gallery").each(function(index, element) {
            var swipergallery = new Swiper(element, {
                slidesPerView: 1.2,
                spaceBetween: 30,
                mousewheel: {
                    enable: true,
                    forceToAxis: true,
                    releaseOnEdges: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 30
                    },
                    992: {
                        // slidesPerView: 3.5,
                        slidesPerView: 3,
                        spaceBetween: 30
                    },
                },
                pagination: {
                    el: ".swiper-pagination",
                    dynamicBullets: true,
                    clickable: true,
                },
                a11y: {
                    slideRole: 'link',
                }
            });
            /* check, if only one slide for custom layout */
            var slidescount = ($(this).find(".swiper-wrapper .swiper-slide").length);
            if(slidescount == 1) {
                $(this).addClass( "singleslide" );
            }
        });

    }

    if ( $( ".gallery" ).length ) {
        /* Gallery */
        $(".gallery").each(function(index, galleryelement) {
            const swiper = new Swiper(galleryelement, {
                // Optional parameters
                loop: false,
                slidesPerView: 'auto',
                spaceBetween: 30,
                mousewheel: {
                 enable: true,
                    forceToAxis: true,
                    releaseOnEdges: true,
                },
                // If we need pagination
                pagination: {
                    el: '.swiper-pagination',
                    dynamicBullets: true,
                    clickable: true,
                },

                // Navigation arrows
                // navigation: {
                //     nextEl: '.swiper-next',
                //     prevEl: '.swiper-prev',
                // },

                // And if we need scrollbar
                // scrollbar: {
                //     el: '.swiper-scrollbar',
                // },
            });
        });
    }




    if ( $( "#header-carousel" ).length ) {
        var slideWrapper = $("#header-carousel"),
            iframes = slideWrapper.find('.yt-player'),
            lazyImages = slideWrapper.find('.image'),
            lazyCounter = 0;

        if (iframes.length){

            // 2. This code loads the IFrame Player API code asynchronously.
            var tag = document.createElement('script');

            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            var players = [];

            // 3. This function creates an <iframe> (and YouTube player)
            //    after the API code downloads.
            function onYouTubeIframeAPIReady() {
                // Check all slides and initialize video players
                var swiperElement = document.getElementById('header-carousel');
                var slides = swiperElement.getElementsByClassName('swiper-slide');
                var ytslide = false;
                // console.log('Slides Length: ' + slides.length);

                for (var i=1; i < slides.length; i++) {

                    ytslide = slides[i].classList.contains('youtube');

                    if (ytslide) {
                        var element = slides[i].getElementsByClassName('yt-player')[0];
                        var id = element.getAttribute('data-id');

                        var player = new YT.Player(element, {
                            height: '315',
                            width: '560',
                            videoId: id,
                            playerVars: {
                                autoplay: false,
                                color: '#7fbc03',
                                modestbranding: true,
                                rel: 0
                            },
                            events: {
                                'onReady': onPlayerReady,
                                'onStateChange': onPlayerStateChange
                            }
                        });
                        //players.push(player);
                        players[i] = player;
                    }
                }
                // 4. The API will call this function when the video player is ready.
                function onPlayerReady(event) {
                    // player.seekTo(1, true);
                    // event.target.playVideo();
                    // console.log(slideWrapper.activeIndex);
                    // players[slideWrapper.activeIndex].seekTo(0);
                    // players[slideWrapper.activeIndex].playVideo();
                }
                // 5. The API calls this function when the player's state changes.
                //    The function indicates that when playing a video (state=1),
                function onPlayerStateChange(event) {
                    //playing(1) or paused (2)
                    if ((event.data == 1) || (event.data == 2)) {
                        //if (event.data == YT.PlayerState.PLAYING && !done) {
                        slideWrapper.autoplay.stop();
                    }
                    //Video ended
                    else if (event.data == 0) {
                        slideWrapper.slideNext();
                        players[slideWrapper.previousIndex].seekTo(0);
                        players[slideWrapper.previousIndex].stopVideo();
                        slideWrapper.autoplay.start();
                    }
                    else {
                        slideWrapper.autoplay.start();
                    }
                }
            }
        }






        // POST commands to YouTube or Vimeo API
        function postMessageToPlayer(player, command){
            // console.log('Player: ' + player);
            // console.log('Command: ' + JSON.stringify(command));
            if (player == null || command == null) return;
            player.contentWindow.postMessage(JSON.stringify(command), "*");
        }

// When the slide is changing
        function playPauseVideo(swiper, control){
            var currentSlide, prevSlide, slideType, startTime, player, video;

            currentSlide = $('#header-carousel').find(".swiper-slide-active");
            prevSlide    = $('#header-carousel').find(".swiper-slide-prev");
            if ((currentSlide).hasClass('swiper-slide')) {
                slideType = currentSlide.prop("class").split(" ")[1];
            }
            // console.log('slideType: ' + slideType);
            // console.log('currentSlide' + currentSlide);
            player = currentSlide.find("iframe").get(0);


            if (slideType === "vimeo") {
                switch (control) {
                    case "play":
                        if (!currentSlide.hasClass('started')) {
                            currentSlide.addClass('started');
                            postMessageToPlayer(player, {
                                "method": "setCurrentTime",
                                "value" : startTime
                            });
                        }
                        postMessageToPlayer(player, {
                            "method": "play",
                            "value" : 1
                        });
                        break;
                    case "pause":
                        postMessageToPlayer(player, {
                            "method": "pause",
                            "value": 1
                        });
                        break;
                }
            } else if (slideType === "youtube-sound") {
                // console.log('YT-sound-match');
                // console.log('control: ' + control);
                switch (control) {
                    case "play":
                        postMessageToPlayer(player, {
                            "event": "command",
                            // "func": "mute"
                        });
                        postMessageToPlayer(player, {
                            "event": "command",
                            "func": "playVideo"
                        });
                        break;
                    case "pause":
                        postMessageToPlayer(player, {
                            "event": "command",
                            "func": "pauseVideo"
                        });
                        break;
                }
            }  else if (slideType === "youtube") {
                switch (control) {
                    case "play":
                        postMessageToPlayer(player, {
                            "event": "command",
                            "func": "mute"
                        });
                        postMessageToPlayer(player, {
                            "event": "command",
                            "func": "playVideo"
                        });
                        break;
                    case "pause":
                        postMessageToPlayer(player, {
                            "event": "command",
                            "func": "pauseVideo"
                        });
                        break;
                }
            } else if (slideType === "video") {
                video = currentSlide.find("video").get(0);

                if (video != null) {
                    if (control === "play"){
                        video.play();
                        // currentSlide.find("video").get(0).play();
                    } else {
                        video.pause();
                    }

                    video.onplaying = function (){
                        slideWrapper.autoplay.stop();
                    }
                    video.onended = function (){
                        slideWrapper.slideNext();
                        slideWrapper.autoplay.start();
                    }
                }
            }
        }


// DOM Ready
        $(function() {
            //start the slider
            var swiper;
            slideWrapper = new Swiper("#header-carousel", {
                mousewheel: {
                 enable: true,
                    forceToAxis: true,
                    releaseOnEdges: true,
                },
                a11y: true,
                effect: "fade",
                rewind: true,
                speed: 100,
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".swiper-pagination",
                    dynamicBullets: true,
                    clickable: true,
                },
                on: {
                    afterInit: function (swiper){
                        // console.log("SwiperInit");
                        //swiper = $('#header-carousel').find(".swiper-slide-active");
                        setTimeout(function(){
                            //playPauseVideo(swiper,"play");
                            // console.log('GO!');
                            //swiper = $('#header-carousel').find(".swiper-slide-active");
                            playPauseVideo(swiper,"play");
                        }, 1000);
                    },
                    //realIndexChange: function(swiper) {
                    //   console.log("slideChangeTransitionStart");
                    //  var swiperprev = $('#header-carousel').find(".swiper-slide-prev");
                    //  playPauseVideo(swiper,"pause");
                    //},
                    slideChangeTransitionStart: function(swiper) {
                        // console.log("slideChangeTransitionEnd");
                        //swiper = $(swiper.currentTarget);
                        //swiper = $('#header-carousel').find(".swiper-slide-active");
                        playPauseVideo(swiper,"play");
                    },
                },
            });

            // Carousel-Button Pause/Play
            $('.playButton').on('click',function (swiper) {
                if ( $( "#header-carousel" ).length ) {
                    slideWrapper.autoplay.start();
                    playPauseVideo(swiper,"play");
                }
                $(this).hide();
                $(this).siblings('.pauseButton').show();
                $(this).closest('.carousel').carousel('cycle');
            });
            $('.pauseButton').on('click',function (swiper) {
                if ( $( "#header-carousel" ).length ) {
                    slideWrapper.autoplay.stop();
                    playPauseVideo(swiper,"pause");
                }
                $(this).hide();
                $(this).siblings('.playButton').show();
                $(this).closest('.carousel').carousel('pause');
            });
        });
    }






    /**
     * Name           : Navigation
     * Beschreibung   : -
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : -
     */
    /*Bei Klick auf Hamburger öffnen*/
    $(".navbar-toggle").click( function(){
        $('.mobile-navigation').toggleClass('active'); //wird für GAGG noch benötigt
        $('.navigationlayer').toggleClass('active');
        $('.overlay-navi').toggleClass('active');
    });

    /* Navigation öffnen via Skip-Link */
    $('a[href$="#nav-main"]').keypress(function(event){
        event.preventDefault();
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if(keycode == '13'){
            $('.navigationlayer').toggleClass('active');
            $('.overlay-navi').toggleClass('active');
        }
    });

    /*Bei Klick auf Lupe Suchlayer öffnen*/
    $(".search-toggle").click( function(){
        $('.searchlayer').toggleClass('active');
    });

    /*neue mobile Navi (Gaggenau)*/
    $(".header__navigation__list--mainicon").on('click', function(){
        $(this).find(".arrow--down").toggleClass('active');
        $(this).find(".arrow--up").toggleClass('active');
        $(this).parent().next().toggleClass('active');
        // $(this).parent().next(".exp-body").scrollIntoView({
        //   behavior: "smooth"
        // });
    });


    /* neues Hybrid-Menü (Desktop & mobile) (Waldseebad) */

    /* Adds functionality to the top-level-menu-points to toggle the corresponding submenu on the desktop viewport. */
    $('.hybrid-menu .lvl1 > li > .lvl_headline > a').each(function () {
        $(this).click(function (e) {
            toggleSubmenuDesktop($(this), e)
            // $(this).siblings('.toggleSubMenu.search-toggle {\n' +
            //     '  background: none;\n' +
            //     '  border: none;\n' +
            //     '}').toggleClass('open');
        })
    });

    /* Arrow to open submenu (Arrows only visible on mobile) */
    $('.toggleSubMenu').each(function () {
        $(this).click(function (e) {
            $(this).closest('li').find('.submenu').first().toggleClass('open');
            $(this).toggleClass('open');
        })
    });



    /* Toggles submenu when in the menu and on a desktop viewport */
    function toggleSubmenuDesktop($this, e) {
        if (window.matchMedia("(min-width: 992px)").matches) {
            if (!$this.hasClass('open')) {
                $('.hybrid-menu ul li a').removeClass('open');
                $('.submenu').removeClass('open');
                e.preventDefault();
                $this.parent().siblings('.submenu').addClass('open');
                $this.addClass('open');
                //ariaExpandedTrue($this);
            }
            else {
                $('.submenu').removeClass('open');
                $this.removeClass('open');
                e.preventDefault();
                //ariaExpandedFalse($this);
            }
        }
    }

    // Bei aktiven Navipunkt, Navigation entsprechend geöffnet darstellen
    $('.hybrid-menu .active').each(function() {
        // Iteriere durch jedes gefundene .active Element
        $(this).parents('.submenu').each(function() {
            // Füge der Elternklasse .submenu die Klasse "open" hinzu
            $(this).addClass('open');
        });
    });




    /* Highlighting der Jumplist (Songtexte) */
    $(".card-group").onClassChange(function (el){
        // reset possible active classes
        $('.swipeable-navigation .group-tab').removeClass("active");
        // set class 'active' on each Navi-Item if Content-Item has class 'active'
        $('.card-group.active').each(function(i, obj) {
            // console.log(obj.id);
            $('.'+obj.id).addClass("active");
            if ( $('.swipeable-navigation').length ) {
                var myScrollPos = $('.' + obj.id).offset().left  - $('.swipeable-navigation').width();
                // console.log(myScrollPos);
                $('.swipeable-navigation').scrollLeft(myScrollPos);
            }
        });
    });

    const observer_jumplist = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            entry.target.classList.toggle('active', entry.isIntersecting);
        });
    });
    const targets_jumplist = document.querySelectorAll('.card-group');
    for (const target of targets_jumplist) {
        observer_jumplist.observe(target)
    }



// Icons für Aufgussplan
    var iconContainers = document.querySelectorAll(".slot-infusion");

    iconContainers.forEach(function(iconContainer) {
        var anzahlIcons = parseInt(iconContainer.dataset.count); // Anzahl aus dem data-Attribut lesen

        // Icons dynamisch erzeugen und zum Container hinzufügen
        for (var i = 0; i < anzahlIcons; i++) {
            var icon = document.createElement("i");
            icon.classList.add("icon-soup-ladle");
            // icon.src = "/assets/mandator/rotherma/img/icon-soup-ladle.svg"; // Pfad zur SVG-Datei
            icon.alt = "Aufguss-Icon";
            iconContainer.appendChild(icon);
        }
    });

});

// Aktiven Slot kennzeichnen und automatisch Liste aktualisieren
// Funktion zum Markieren des aktuellen Termins
function markiereAktuellenTermin() {
    var termine = document.querySelectorAll('.slot');
    var jetzt = new Date();
    var aktuelleZeit = jetzt.getHours() * 60 + jetzt.getMinutes(); // Aktuelle Zeit in Minuten seit Mitternacht

    termine.forEach(function(termin) {
        var slotTime = termin.querySelector('.slot-time').textContent;
        var slotHour = parseInt(slotTime.split(':')[0]);
        var slotMinute = parseInt(slotTime.split(':')[1]);
        var slotZeit = slotHour * 60 + slotMinute; // Zeit des Termins in Minuten seit Mitternacht

        if (aktuelleZeit >= slotZeit && aktuelleZeit < slotZeit + 30) { // Aktiver Termin dauert 30 Minuten
            termin.classList.add('active');
        } else {
            termin.classList.remove('active');
        }
    });
}

// Funktion zum automatischen Aktualisieren der Liste
function automatischeAktualisierung() {
    markiereAktuellenTermin();
    setInterval(markiereAktuellenTermin, 60000); // Alle 60 Sekunden aktualisieren
}

// Automatische Aktualisierung starten, wenn das Dokument geladen ist
document.addEventListener('DOMContentLoaded', automatischeAktualisierung);





